import React, { useCallback, useEffect, useState } from 'react';
import api from '../utils/api';
import './ServiceOrdersModal.css';

const STATUS_COLORS = {
  Completed: '#34d399', 'In progress': '#fbbf24', Processing: '#fbbf24',
  Pending: '#00e0ff', Partial: '#a78bfa', Canceled: '#f87171', Refunded: '#a78bfa',
};

// User-scoped drill-down for a single SMM service. Opened from the Growth
// tab's "Where you invest" rows. Lists ONLY the caller's own orders for that
// service (internal order codes — never the provider number).
const ServiceOrdersModal = ({ service, onClose }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    if (!service) return;
    setLoading(true);
    try {
      const res = await api.get('/user/analytics/service', { params: { service, range: 'all' } });
      setData(res.data);
      setError('');
    } catch (e) {
      setError(e?.response?.data?.message || e?.message || 'Failed to load orders');
    } finally {
      setLoading(false);
    }
  }, [service]);

  useEffect(() => { load(); }, [load]);

  if (!service) return null;
  const totals = data?.totals;
  const orders = data?.orders || [];

  return (
    <div className="som-overlay" onClick={onClose}>
      <div className="som-modal" onClick={(e) => e.stopPropagation()}>
        <button className="som-close" type="button" onClick={onClose} aria-label="Close">×</button>
        <span className="som-eyebrow">Your orders for</span>
        <h3 className="som-title">{service}</h3>

        {totals && (
          <div className="som-stats">
            <div><em>Orders</em><b>{totals.orders}</b></div>
            <div><em>Spent</em><b>${Number(totals.revenue || 0).toFixed(2)}</b></div>
            <div><em>Quantity</em><b>{Number(totals.quantity || 0).toLocaleString()}</b></div>
            {Number(totals.refunds || 0) > 0 && <div><em>Refunded</em><b>${Number(totals.refunds).toFixed(2)}</b></div>}
          </div>
        )}

        {loading ? (
          <div className="som-empty">Loading…</div>
        ) : error ? (
          <div className="som-error">⚠ {error}</div>
        ) : orders.length === 0 ? (
          <div className="som-empty">No orders for this service.</div>
        ) : (
          <div className="som-table-wrap">
            <table className="som-table">
              <thead>
                <tr><th>Order</th><th>Qty</th><th>Status</th><th>Remains</th><th>Charged</th><th>When</th></tr>
              </thead>
              <tbody>
                {orders.map((o) => (
                  <tr key={o.db_id}>
                    <td><strong>{o.order_id}</strong></td>
                    <td>{Number(o.quantity || 0).toLocaleString()}</td>
                    <td><span className="som-chip" style={{ '--c': STATUS_COLORS[o.status] || '#9aa' }}>{o.status}</span></td>
                    <td>{o.remains != null ? Number(o.remains).toLocaleString() : '—'}</td>
                    <td>${Number(o.charged_usd || 0).toFixed(2)}</td>
                    <td>{o.created_at ? new Date(o.created_at).toLocaleDateString() : '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default ServiceOrdersModal;
